import { render, staticRenderFns } from "./RequestDeleteLessonCard.vue?vue&type=template&id=48788168&scoped=true&"
import script from "./RequestDeleteLessonCard.vue?vue&type=script&lang=js&"
export * from "./RequestDeleteLessonCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestDeleteLessonCard.vue?vue&type=style&index=0&id=48788168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48788168",
  null
  
)

export default component.exports